import { apiFetch } from "../utils/apiFetch";
import { API_BASE_OPERATOR as API_BASE } from "../config/vars";

export async function fetchOperatorNetworkLogo() {
    const res = await apiFetch(`${API_BASE}/networks/operator/logo`);
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося завантажити логотип");
    }
    return await res.json();
}

export async function uploadOperatorNetworkLogo(file) {
    const form = new FormData();
    form.append("file", file);
    const res = await apiFetch(`${API_BASE}/networks/operator/logo`, {
        method: "POST",
        body: form,
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося зберегти логотип");
    }
    return await res.json();
}

export async function deleteOperatorNetworkLogo() {
    const res = await apiFetch(`${API_BASE}/networks/operator/logo`, {
        method: "DELETE",
    });
    if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.detail || "Не вдалося видалити логотип");
    }
    return await res.json();
}

export function operatorNetworkLogoUrl(fileUrl) {
    if (!fileUrl) return "";
    return `${API_BASE}/networks/operator/logo/download/${encodeURIComponent(fileUrl)}`;
}

export async function fetchOperatorNetworkLogoBlob(fileUrl) {
    const res = await apiFetch(operatorNetworkLogoUrl(fileUrl));
    if (!res.ok) throw new Error("Не вдалося завантажити файл логотипу");
    return await res.blob();
}
